/***************************************************
 * Created by gongyanyu on 2022/10/18 14:44. *
 ***************************************************/
// @ts-ignore
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { RecordValue, SimpleRecord, TreeRecord } from '../interfaces/types';
import { flat } from '../helpers/flat';
import { ListLikeVM } from './ListLikeVM';
import { computed, makeObservable, override } from 'mobx';
import { makeMetadata, property, transformer } from '../helpers/decorators';

export class TreeLikeVM extends ListLikeVM {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  private _FLAT_DATA_: TreeRecord[];

  private getNodeInTiledData(node: TreeRecord | string | number): TreeRecord {
    const value = typeof node === 'object' ? (node as any)[this.$identifierField] : node;
    return this._FLAT_DATA_.find((d: any) => d[this.$identifierField] === value);
  }

  @transformer
  private $dataSetterTransformer(data: TreeRecord[]) {
    this._FLAT_DATA_ = flat(data);
    return data;
  }

  /**
   * 为当前VM添加一个节点
   * @param node -  节点数据
   * @param index - 所要插入的位置
   * @param parentKey - 所要添加的父节点ID
   *
   * @example
   * ```ts
   * $vm.insertNode({id : "", key0: "", key1: "", ...})
   * ```
   */
  @override // @ts-ignore
  insertNode(node: TreeRecord, parentKey?: RecordValue, index?: number): this {
    const parent = this.getNodeInTiledData(parentKey);
    parent.children.splice(index, 0, node);
    return this;
  }

  @override removeNode(key: SimpleRecord | RecordValue): this {
    const node = this.getNodeInTiledData(key);
    const index = this._FLAT_DATA_.findIndex((d: any) => d[this.$identifierField] === (node as any)[this.$identifierField]);
    if (index > -1) this._FLAT_DATA_.splice(index, 1);
    return this;
  }

  @override updateNode(node: SimpleRecord): this {
    const index = this._FLAT_DATA_.findIndex((d: any) => d[this.$identifierField] === (node as any)[this.$identifierField]);
    if (index > -1) {
      this._FLAT_DATA_[index] = node;
    } else {
      this.insertNode(node);
    }
    return this;
  }

  hasNode(node: SimpleRecord | RecordValue): boolean {
    const _key = typeof node === 'object' ? node[this.$identifierField] : node;
    const index = this._FLAT_DATA_.findIndex((d: any) => d[this.$identifierField] === _key);
    return index > -1;
  }

  /**
   * 获取`id`对应的行数据
   * @param node
   */
  getNode(node: SimpleRecord | RecordValue): SimpleRecord {
    const _key = typeof node === 'object' ? (node as any)[this.$identifierField] : node;
    return this._FLAT_DATA_?.find((d: any) => d[this.$identifierField] === _key);
  }

  @property @computed get treeData(): any[] {
    return this.data;
  }

  set treeData(o: any[]) {
    this.setData(o);
  }
}
